module.exports = __webpack_public_path__ + "img/disguised-ads.3ad99751.jpg";